const barcode = require('./barcode');
const iziToast = require("izitoast");

var bulk_page = {

    selectOpen: false,
    suggestTimeout: null,

    init: function () {
        var $this = this;

        // --- Element Selectors ---
        const $contractIdInput = $("#contract_id");
        const $suggestInput = $("#suggest_input");
        const $suggestSelect = $("#suggest_select");
        const $chargeSelect = $("#charge_select");
        const $scannerToggle = $('#scanner_toggle');
        const $submitManualBtn = $('#submit_manual');
        const $codePart = $('.form__part--code');
        const $suggestPart = $('.form__part--suggest');

        // --- onSubmit Handler ---
        var onSubmit = function (value) {
            if (!value) return;

            var chargeId = $chargeSelect.val();

            // console.log('submit', chargeId, value);

            return $.ajax({
                url: 'index.php',
                data: {
                    ajax: 1,
                    page: 'ferda',
                    subpage: 'bulk',
                    bulkSubmit: 1,
                    charge: chargeId,
                    id: value
                },
                dataType: 'json'
            }).done((response) => {
                // console.log('submit', response);
                $contractIdInput.val('');
                $suggestInput.val('');
                if (response.result == 'success') {
                    $contractIdInput.addClass('success');
                    setTimeout(() => $contractIdInput.removeClass('success'), 500);
                } else if (response.message && response.message.length > 0) {
                    iziToast.error({
                        title: '',
                        message: response.message.join('<br />'),
                        position: 'center',
                    });
                }
                // Always switch back to scanner mode after any submission
                if ($scannerToggle.is(':checked')) {
                     $scannerToggle.prop('checked', false);
                }
                // We must trigger change to run the handler that switches the UI
                $scannerToggle.trigger('change');

            }).fail(function (xhr) {
                iziToast.error({ message: xhr.responseText });
            });
        };

        // --- Barcode Initialization ---
        var onBlur = function () {
            var blurEl = $(this);
            var interval = setInterval(function () {
                if (!$this.isSelectOpen()) {
                    blurEl.cursorFocus();
                    clearInterval(interval);
                }
            }, 500);
        };
        barcode.init($contractIdInput, onSubmit, onBlur);

        // --- UI Mode Switching ---
        const switchToScannerMode = () => {
            $suggestPart.slideUp('fast', () => {
                $codePart.slideDown('fast', () => {
                    barcode.enable();
                    $contractIdInput.cursorFocus();
                });
            });
        };

        const switchToManualMode = () => {
            barcode.disable();
            $codePart.slideUp('fast', () => {
                $suggestPart.slideDown('fast', () => {
                    $suggestInput.cursorFocus();
                });
            });
        };

        $scannerToggle.on('change', function () {
            if ($(this).is(':checked')) {
                switchToManualMode();
            } else {
                switchToScannerMode();
            }
        });

        // --- Suggest Input Logic ---
        $suggestInput.on('keyup', function (e) {
            // On Enter, we have two scenarios
            if (e.key === 'Enter') {
                // 1. If the suggestion list is open, 'Enter' confirms the selection.
                if ($suggestSelect.is(':visible') && $suggestSelect.val()) {
                    $suggestSelect.trigger('change'); // This will trigger the selection logic
                } else {
                // 2. If the list is not open (or no item is selected), 'Enter' submits the form.
                    onSubmit($contractIdInput.val());
                }
                return; // Prevent further actions
            }

            clearTimeout($this.suggestTimeout);
            $this.suggestTimeout = setTimeout(() => {
                var query = $(this).val();
                if (query.length < 2) {
                    $suggestSelect.hide();
                    return;
                }

                $.ajax({
                    url: 'index.php',
                    data: {
                        page: 'ferda',
                        subpage: 'bulk',
                        action: 'suggest',
                        query: query
                    },
                    dataType: 'json'
                }).done((response) => {
                    $suggestSelect.empty();
                    if(response.success && Object.keys(response.data).length > 0) {
                        $.each(response.data, function (id, name) {
                            $suggestSelect.append($('<option>', {
                                value: id,
                                text: name
                            }));
                        });
                        $suggestSelect.show();
                    } else {
                        $suggestSelect.hide();
                    }
                });
            }, 500);
        });

        // --- Suggest Select Logic (Selection only) ---
        const selectItem = () => {
            var selectedId = $suggestSelect.val();
            var selectedText = $suggestSelect.find('option:selected').text();
            $suggestInput.val(selectedText);
            $contractIdInput.val(selectedId); // Populate the hidden field
            $suggestSelect.hide();
            $suggestInput.focus(); // Return focus to the input for the final 'Enter' or button press
            // console.log("selected", selectedId, $contractIdInput.val());
        };

        $suggestSelect.on('change', selectItem);
        $suggestSelect.on('click', selectItem); // Handle taps on touch devices
        $suggestSelect.on('keyup', function(e) {
            if (e.key === 'Enter') {
                selectItem();
            }
        });

        // --- Manual Submit Button ---
        $submitManualBtn.on('click', function() {
            onSubmit($contractIdInput.val());
        });

        // --- Charge Select Focus Handling ---
        $chargeSelect.on("click", () => { $this.selectOpen = !$this.selectOpen; });
        $chargeSelect.on("blur", () => { if ($this.selectOpen) $this.selectOpen = false; });
        $(document).keyup((e) => { if (e.keyCode == 27 && $this.selectOpen) $this.selectOpen = false; });

        // --- Initial State on Page Load ---
        $suggestPart.hide();
        $codePart.show();
        barcode.enable();
    },

    isSelectOpen: function () {
        return this.selectOpen;
    }
};

module.exports = bulk_page;